//
//
//
//
//

export default {
    name: 'QR',
    props: {
        search_tip: {
            type: String
        }
    }
}
